import styled from "styled-components"
import Announcements from "../Components/Announcements"
import Footer from "../Components/Footer"
import Navbar from "../Components/Navbar"
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import {Link} from 'react-router-dom'




const Container = styled.div`

`
const Wrapper = styled.div`
    padding: 20px;
`
const Title = styled.h1`
    font-weight: 300;
    font-size: 50px;
    text-align: center;
`
const TopContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
`
const TopButtom = styled.button`
    padding: 10px 15px;
    border-style: none;
    cursor: pointer;
    background-color: lightgrey;
    font-weight: 400;
    font-size: 15px;
    &:hover{
        background-color: #bff7bfcc;
        transform: scale(1.05);
    }
`


const TopTexts = styled.div`
    padding: 10px 20px;
    font-weight: 600;
    cursor: pointer;
    border: none;
`
const TopText = styled.span`
    margin: 0 20px;
    font-weight: 300;
    cursor: pointer;
    text-decoration: underline;
`
const InfoContainer = styled.div`
    flex: 3;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`
const Service = styled.div`
    margin: 15px;
    display: flex;
    justify-content: space-between;
`
const BottomContainer = styled.div`
    display: flex;
    justify-content: space-between;
`

const ItemDetails = styled.div`
    flex: 2;
    display: flex;
`
const Image = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`
const Details = styled.div`
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
`
const ItemName = styled.span`
`
const ItemDescription = styled.div`
`
const PriceDetails = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`
const ProductAmountContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    
` 

const ProductAmonut = styled.span`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 5px;
    width: 40px;
    height: 30px;
    background-color: #bff7bfcc;
    font-size: 22px;
    margin-bottom: 20px;
`
const PriceToPay = styled.div`
    font-size: 30px;
    font-weight: 200;
`
const PriceAmount = styled.span`
    font-size: 22px; 
`
const PriceInNumbers = styled.h3`
    font-size: 25px;
`
const Hr = styled.hr`
    background-color: #eee;
    border: none;
    height: 5px;
`
const Summary = styled.div`
    margin: 10px;
    flex: 1;
    border: 2px solid lightgray;
    border-radius: 4px;
    padding: 20px;
    height: 50vh;
`
const SummaryTitle = styled.h2`
    font-weight: 200;
    font-size: 40px;
`
const SummaryItem = styled.div`
    margin: 30px 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    font-weight: ${props => props.type === "total" && "500"};
    font-size: ${props => props.type === "total" && "24px"};
`
const SummaryItemText = styled.span`
    font-weight: 400;
`
const SummaryItemPrice = styled.span`
    font-weight: ${props => props.type === "btnfw" && "6500"};
`
const MainButton = styled.button`
    width: 100%;
    padding: 10px;
    background-color: black;
    color: white;
    font-weight: 600;
    font-size: 18px;
    margin: 25px 0;
`
const LinkStyle = {
    color:"black",
    textDecoration: "none"
}




const Cart = () => {
    return (
        <Container>
            <Navbar />
            <Announcements />
            <Wrapper>
                <Title>Your cart</Title>
                <TopContainer>
                    <Link style={LinkStyle} to="/">
                        <TopButtom> Back to home </TopButtom>
                    </Link>
                    <TopTexts>
                        <TopText> Shopping bag(2) </TopText>
                        <TopText> Your wishlist (0) </TopText>
                    </TopTexts>
                    <TopButtom style={{backgroundColor: "grey"}} > Checkout now </TopButtom>
                </TopContainer>
                <BottomContainer>
                    <InfoContainer>
                            <Service>
                                <ItemDetails>
                                    <Image src="https://images.pexels.com/photos/4846097/pexels-photo-4846097.jpeg?cs=srgb&dl=pexels-rachel-claire-4846097.jpg&fm=jpg" />
                                    <Details>
                                        <ItemName> <b> Item: </b> Sofa </ItemName>
                                        <ItemDescription> <b> Description: </b> We price upholstery differently depending on the furniture piece and size. </ItemDescription>
                                    </Details>
                                </ItemDetails>
                                <PriceDetails>
                                    <ProductAmountContainer>
                                        <RemoveIcon />
                                        <ProductAmonut > 2 </ProductAmonut>    
                                        <AddIcon />
                                    </ProductAmountContainer>
                                    <PriceToPay>
                                        <PriceAmount>
                                            To pay:
                                        </PriceAmount>
                                        <PriceInNumbers>
                                            $ 1,000
                                        </PriceInNumbers>
                                    </PriceToPay>
                                </PriceDetails>
                            </Service>
                        <Hr />
                        <Service>
                            <ItemDetails>
                                <Image src="https://imageresizer.furnituredealer.net/img/remote/images.furnituredealer.net/img/products%2ffusion_furniture%2fcolor%2f4480-kp_4483basic%20wool-b1.jpg?width=878&height=600&scale=both&trim.threshold=80" />
                                <Details>
                                    <ItemName> <b> Item: </b> Ottoman </ItemName>
                                    <ItemDescription> <b> Description: </b> We price upholstery differently depending on the furniture piece and size. </ItemDescription>
                                </Details>
                            </ItemDetails>
                            <PriceDetails>
                                <ProductAmountContainer>
                                    <RemoveIcon />
                                    <ProductAmonut > 1 </ProductAmonut>    
                                    <AddIcon />
                                </ProductAmountContainer>
                                <PriceToPay>
                                    <PriceAmount>
                                        To pay:
                                    </PriceAmount>
                                    <PriceInNumbers>
                                        $ 350
                                    </PriceInNumbers>
                                </PriceToPay>
                            </PriceDetails>
                        </Service>
                        <Hr />
                        <Service>
                            <ItemDetails>
                                <Image src="https://housewifehowtos.com/wp-content/uploads/2021/04/How-to-Clean-a-Mattress-Get-Rid-of-Stains-and-Smells-1024x683.jpeg.webp" />
                                <Details>
                                    <ItemName> <b> Item: </b> Mattress King </ItemName>
                                    <ItemDescription> <b> Description: </b> We price upholstery differently depending on the furniture piece and size. </ItemDescription>
                                </Details>
                            </ItemDetails>
                            <PriceDetails>
                                <ProductAmountContainer>
                                    <RemoveIcon />
                                    <ProductAmonut > 3 </ProductAmonut>    
                                    <AddIcon />
                                </ProductAmountContainer>
                                <PriceToPay>
                                    <PriceAmount>
                                        To pay:
                                    </PriceAmount>
                                    <PriceInNumbers>
                                        $ 2,400
                                    </PriceInNumbers>
                                </PriceToPay>
                            </PriceDetails>
                        </Service>
                        <Hr />
                    </InfoContainer>
                    <Summary>
                        <SummaryTitle>Order summary</SummaryTitle>
                        <SummaryItem>
                            <SummaryItemText> Subtotal </SummaryItemText>
                            <SummaryItemPrice> $ 3,750 </SummaryItemPrice>
                        </SummaryItem>
                        <SummaryItem>
                            <SummaryItemText> Discount </SummaryItemText>
                            <SummaryItemPrice> $ - 461 </SummaryItemPrice>
                        </SummaryItem>
                        <SummaryItem type="total" >
                            <SummaryItemText type="btnfw" > Subtotal </SummaryItemText>
                            <SummaryItemPrice type="btnfw" > $ 3,289 </SummaryItemPrice>
                        </SummaryItem>
                        <MainButton>Pay now</MainButton>
                    </Summary>
                </BottomContainer>
                </Wrapper>
            <Footer />
        </Container>
    )
}

export default Cart
